@for (content of contentList; track content) {
  <div [id]="content.id" class="content" [ngClass]="content.hostClass + ' ' + (content.class || '') + (content.viewType === eContentViewType.Carousel ? ' carousel slide' : '')">
    @switch (content?.viewType) {
      @case (eContentViewType.Default) {
        @for (widget of content?.contentWidgetList; track widget) {
          <ng-container
            *ngTemplateOutlet="
              widgetlist;
              context: {
                $implicit: {
                  content: content,
                  widget: widget,
                },
              }
            "
          ></ng-container>
        }
      }
      @case (eContentViewType.Gallery) {
        @for (widget of content?.contentWidgetList; track widget) {
          <ng-container
            *ngTemplateOutlet="
              widgetlist;
              context: {
                $implicit: {
                  content: content,
                  widget: widget,
                },
              }
            "
          ></ng-container>
        }
      }
      @case (eContentViewType.Carousel) {
        <!-- original 
        <div [id]="content.id" [ngClass]="'carousel slide ' + (content.class || '')" data-bs-ride="carousel" data-bs-interval="10000" data-bs-pause="false">
        -->
        <!-- no automatic scrolling for carousel with id favorites -->
        <div
          [id]="content.id"
          [ngClass]="'carousel fullsize-carousel slide ' + (content.class || '')"
          [attr.data-bs-ride]="content.class?.includes('multi-slide') ? null : 'carousel'"
          [attr.data-bs-interval]="content.class?.includes('multi-slide') ? null : '10000'"
          data-bs-pause="false"
        >
          <div class="carousel-inner">
            @for (widget of content?.contentWidgetList; track widget; let i = $index) {
              <!-- <div class="carousel-item active">
                <a href="/about" class="carousel-link">
                  <img src="https://localhost:44349/assetsCms/images/slider-placeholder_only-image.jpg" class="d-block w-100" alt="Slide 1" />
                  <h5 class="carousel-title">Nahrungsmittel</h5>
                  <p class="carousel-text">Genuss made in Austria</p>
                </a>
              </div>

              <div class="carousel-item">
                <a href="/services" class="carousel-link">
                  <img src="https://localhost:44349/assetsCms/images/slider-placeholder_only-image.jpg" class="d-block w-100" alt="Slide 2" />
                  <h5 class="carousel-title">Spirituosen</h5>
                  <p class="carousel-text">Flüssiger Genuss</p>
                </a>
              </div> -->

              <div class="carousel-item" [class.active]="i == currentCarouselItem">
                <ng-container
                  *ngTemplateOutlet="
                    widgetlist;
                    context: {
                      $implicit: {
                        content: content,
                        widget: widget,
                      },
                    }
                  "
                ></ng-container>
              </div>
            }
          </div>

          <button class="carousel-control-prev" type="button" [attr.data-bs-target]="'#' + content.id" data-bs-slide="prev" (click)="carouselPrev(content)">
            <span class="carousel-control-prev-icon"></span>
            <span class="visually-hidden">Previous</span>
          </button>

          <button class="carousel-control-next" type="button" [attr.data-bs-target]="'#' + content.id" data-bs-slide="next" (click)="carouselNext(content)">
            <span class="carousel-control-next-icon"></span>
            <span class="visually-hidden">Next</span>
          </button>

          <div class="carousel-indicators">
            @for (widget of content?.contentWidgetList; track widget; let i = $index) {
              <button type="button" [attr.data-bs-target]="'#' + content.id" [attr.data-bs-slide-to]="i" [class.active]="i === 0" [attr.aria-current]="i === 0 ? 'true' : null" [attr.aria-label]="'Slide ' + (i + 1)"></button>
            }
          </div>
        </div>
      }
      @case (undefined) {
        @for (widget of content?.contentWidgetList; track widget) {
          <ng-container
            *ngTemplateOutlet="
              widgetlist;
              context: {
                $implicit: {
                  content: content,
                  widget: widget,
                },
              }
            "
          ></ng-container>
        }
      }
    }
  </div>
}

<ng-template #widgetlist let-param>
  @switch (param.widget.type) {
    <!-- Info Widget -->
    @case (eContentWidgetType.Info) {
      @if (infoWidgetTemplate) {
        <ng-container *ngTemplateOutlet="infoWidgetTemplate; context: { class: param.content.widgetColumnClass, widget: param.widget }"></ng-container>
        <!-- by using "context: {$implicit: { ... }}"" instead of "context: { ... }" you can bundle all parameters together and drop the names. Template and usage example below -->
        <!-- <ng-container *ngTemplateOutlet="infoWidgetImplicitTemplate; context: {$implicit: { class: content.widgetColumnClass, widget: widget }}"></ng-container> -->
      }
      @if (!infoWidgetTemplate) {
        <ng-container *ngTemplateOutlet="infoWidgetDefaultTemplate; context: { class: param.content.widgetColumnClass, widget: param.widget }"></ng-container>
      }
      <ng-template #infoWidgetDefaultTemplate let-class="class" let-widget="widget">
        <app-widget-info [class]="class" [widget]="widget"></app-widget-info>
      </ng-template>
      <!-- by using "context: {$implicit: { ... }}"" instead of "context: { ... }" you can bundle all parameters together and drop the names. Template and usage example below -->
      <!-- <ng-template #infoWidgetImplicitTemplate let-param>
          <app-widget-info [class]="param.class" [widget]="param.widget"></app-widget-info>
        </ng-template> -->
    }
    <!-- Product card Widget -->
    @case (eContentWidgetType.ProductCard) {
      @if (productCardWidgetTemplate) {
        <ng-container *ngTemplateOutlet="productCardWidgetTemplate; context: { class: param.content.widgetColumnClass, widget: param.widget }"></ng-container>
      }
      @if (!productCardWidgetTemplate) {
        <ng-container *ngTemplateOutlet="productCardWidgetDefaultTemplate; context: { class: param.content.widgetColumnClass, widget: param.widget }"></ng-container>
      }
      <ng-template #productCardWidgetDefaultTemplate let-class="class" let-widget="widget">
        <app-widget-product-card [class]="class" [widget]="widget"></app-widget-product-card>
      </ng-template>
    }
    <!-- Text Widget -->
    @case (eContentWidgetType.Text) {
      @if (textWidgetTemplate) {
        <ng-container *ngTemplateOutlet="textWidgetTemplate; context: { class: param.content.widgetColumnClass, widget: param.widget }"></ng-container>
      }
      @if (!textWidgetTemplate) {
        <ng-container *ngTemplateOutlet="textWidgetDefaultTemplate; context: { class: param.content.widgetColumnClass, widget: param.widget }"></ng-container>
      }
      <ng-template #textWidgetDefaultTemplate let-class="class" let-widget="widget">
        <app-widget-text [class]="class" [widget]="widget"></app-widget-text>
      </ng-template>
    }
    <!-- Webtext Widget -->
    @case (eContentWidgetType.WebText) {
      @if (webTextWidgetTemplate) {
        <ng-container *ngTemplateOutlet="webTextWidgetTemplate; context: { class: param.content.widgetColumnClass, widget: param.widget }"></ng-container>
      }
      @if (!webTextWidgetTemplate) {
        <ng-container *ngTemplateOutlet="webTextWidgetDefaultTemplate; context: { class: param.content.widgetColumnClass, widget: param.widget }"></ng-container>
      }
      <ng-template #webTextWidgetDefaultTemplate let-class="class" let-widget="widget">
        <app-widget-web-text-base [class]="class" [widget]="widget"> </app-widget-web-text-base>
      </ng-template>
    }
    <!-- Headline Widget -->
    @case (eContentWidgetType.Headline) {
      @if (headlineWidgetTemplate) {
        <ng-container *ngTemplateOutlet="headlineWidgetTemplate; context: { class: param.content.widgetColumnClass, widget: param.widget }"></ng-container>
      }
      @if (!headlineWidgetTemplate) {
        <ng-container *ngTemplateOutlet="headlineWidgetDefaultTemplate; context: { class: param.content.widgetColumnClass, widget: param.widget }"></ng-container>
      }
      <ng-template #headlineWidgetDefaultTemplate let-class="class" let-widget="widget">
        <app-widget-headline [class]="class" [widget]="widget"></app-widget-headline>
      </ng-template>
    }
    <!-- Content card Widget -->
    @case (eContentWidgetType.ContentCard) {
      @if (contentCardWidgetTemplate) {
        <ng-container *ngTemplateOutlet="contentCardWidgetTemplate; context: { class: param.content.widgetColumnClass, widget: param.widget }"></ng-container>
      }
      @if (!contentCardWidgetTemplate) {
        <ng-container *ngTemplateOutlet="contentCardWidgetDefaultTemplate; context: { class: param.content.widgetColumnClass, widget: param.widget }"></ng-container>
      }
      <ng-template #contentCardWidgetDefaultTemplate let-class="class" let-widget="widget">
        <app-widget-content-card [class]="class" [widget]="widget"></app-widget-content-card>
      </ng-template>
    }
    <!-- Empty Widget -->
    @case (eContentWidgetType.Empty) {
      @if (emptyWidgetTemplate) {
        <ng-container *ngTemplateOutlet="emptyWidgetTemplate; context: { class: param.content.widgetColumnClass, widget: param.widget }"></ng-container>
      }
      @if (!emptyWidgetTemplate) {
        <ng-container *ngTemplateOutlet="emptyWidgetDefaultTemplate; context: { class: param.content.widgetColumnClass, widget: param.widget }"></ng-container>
      }
      <ng-template #emptyWidgetDefaultTemplate let-class="class" let-widget="widget">
        <app-widget-empty [class]="class" [widget]="widget"></app-widget-empty>
      </ng-template>
    }
    <!-- TechGroup card Widget -->
    @case (eContentWidgetType.TechGroupCard) {
      @if (techgroupCardWidgetTemplate) {
        <ng-container *ngTemplateOutlet="techgroupCardWidgetTemplate; context: { class: param.content.widgetColumnClass, widget: param.widget }"></ng-container>
      }
      @if (!techgroupCardWidgetTemplate) {
        <ng-container *ngTemplateOutlet="techgroupCardWidgetDefaultTemplate; context: { class: param.content.widgetColumnClass, widget: param.widget }"></ng-container>
      }
      <ng-template #techgroupCardWidgetDefaultTemplate let-class="class" let-widget="widget">
        <app-widget-tech-group-card-base [class]="class" [widget]="widget"></app-widget-tech-group-card-base>
      </ng-template>
    }
    <!-- Navigation card Widget -->
    @case (eContentWidgetType.NavigationCard) {
      @if (navigationCardWidgetTemplate) {
        <ng-container *ngTemplateOutlet="navigationCardWidgetTemplate; context: { class: param.content.widgetColumnClass, widget: param.widget }"></ng-container>
      }
      @if (!navigationCardWidgetTemplate) {
        <ng-container *ngTemplateOutlet="navigationCardWidgetDefaultTemplate; context: { class: param.content.widgetColumnClass, widget: param.widget }"></ng-container>
      }
      <ng-template #navigationCardWidgetDefaultTemplate let-class="class" let-widget="widget">
        <app-widget-navigation-card [class]="class" [widget]="widget"></app-widget-navigation-card>
      </ng-template>
    }
    <!-- fullsize banner widget -->
    @case (eContentWidgetType.FullsizeBanner) {
      @if (fullsizeBannerWidgetTemplate) {
        <ng-container *ngTemplateOutlet="fullsizeBannerWidgetTemplate; context: { class: param.content.widgetColumnClass, widget: param.widget }"></ng-container>
      }
      @if (!fullsizeBannerWidgetTemplate) {
        <ng-container *ngTemplateOutlet="fullsizeBannerWidgetDefaultTemplate; context: { class: param.content.widgetColumnClass, widget: param.widget }"></ng-container>
      }
      <ng-template #fullsizeBannerWidgetDefaultTemplate let-class="class" let-widget="widget">
        <app-widget-fullsize-banner [class]="class" [widget]="widget"></app-widget-fullsize-banner>
      </ng-template>
    }
    <!-- Image widget -->
    @case (eContentWidgetType.Image) {
      @if (imageWidgetTemplate) {
        <ng-container *ngTemplateOutlet="imageWidgetTemplate; context: { class: param.content.widgetColumnClass, widget: param.widget }"></ng-container>
      }
      @if (!imageWidgetTemplate) {
        <ng-container *ngTemplateOutlet="imageWidgetDefaultTemplate; context: { class: param.content.widgetColumnClass, widget: param.widget }"></ng-container>
      }
      <ng-template #imageWidgetDefaultTemplate let-class="class" let-widget="widget">
        <app-widget-image [class]="class" [widget]="widget"></app-widget-image>
      </ng-template>
    }
    <!-- Breadcrumb Widget -->
    @case (eContentWidgetType.Breadcrumb) {
      @if (breadcrumbWidgetTemplate) {
        <ng-container *ngTemplateOutlet="breadcrumbWidgetTemplate; context: { class: param.content.widgetColumnClass, widget: param.widget }"></ng-container>
      }
      @if (!breadcrumbWidgetTemplate) {
        <ng-container *ngTemplateOutlet="breadcrumbWidgetDefaultTemplate; context: { class: param.content.widgetColumnClass, widget: param.widget }"></ng-container>
      }
      <ng-template #breadcrumbWidgetDefaultTemplate let-class="class" let-widget="widget">
        <app-widget-breadcrumb [class]="class" [widget]="widget"></app-widget-breadcrumb>
      </ng-template>
    }
    <!-- Categories Widget -->
    @case (eContentWidgetType.Categories) {
      @if (categoriesWidgetTemplate) {
        <ng-container *ngTemplateOutlet="categoriesWidgetTemplate; context: { class: param.content.widgetColumnClass, widget: param.widget }"></ng-container>
      }
      @if (!categoriesWidgetTemplate) {
        <ng-container *ngTemplateOutlet="categoriesWidgetDefaultTemplate; context: { class: param.content.widgetColumnClass, widget: param.widget }"></ng-container>
      }
      <ng-template #categoriesWidgetDefaultTemplate let-class="class" let-widget="widget">
        <!-- ToDo: insert default categories widget/implementation here -->
      </ng-template>
    }
    @default {
      <div [class]="param.content.widgetColumnClass"></div>
    }
  }
</ng-template>
